var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00848 6H17.0085L11.9985 12.3L7.00848 6ZM4.25848 5.61C6.27848 8.2 10.0085 13 10.0085 13V19C10.0085 19.55 10.4585 20 11.0085 20H13.0085C13.5585 20 14.0085 19.55 14.0085 19V13C14.0085 13 17.7285 8.2 19.7485 5.61C20.2585 4.95 19.7885 4 18.9585 4H5.04848C4.21848 4 3.74848 4.95 4.25848 5.61Z",
    fill: "#2F74FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterAlt);
export default __webpack_public_path__ + "static/media/filter_alt.46c864f957b2c0726101dcf98fd61af5.svg";
export { ForwardRef as ReactComponent };